export async function loadOutModesUpdater(engine, refresh = true) {
    await engine.addParticleUpdater("outModes", async (container) => {
        const { OutOfCanvasUpdater } = await import("./OutOfCanvasUpdater.js");
        return new OutOfCanvasUpdater(container);
    }, refresh);
}
